export default __webpack_public_path__ + "images/0xc19669a405067927865b40ea045a2baabbbe57f5.png";